import axios from "axios";
import store from "@/store";
import router from "@/router";
const url = process.env.VUE_APP_API_BASE_URL;

const actions = {
  async forgotPassword({ commit }, data) {
    await axios.post(`${url}/auth/forgot-password`, data);
  },
  async createNewPassword({ commit }, data) {
    await axios.post(`${url}/auth/reset-password`, data).then((response) => {
      //router.push({ name: "Login" });
      const ua = navigator.userAgent;
      if (/iPad|iPhone|iPod/.test(ua)) {
        window.location.replace(
          "https://apps.apple.com/es/app/misepis/id6463144377"
        );
      } else {
        window.location.replace(
          "https://play.google.com/store/apps/details?id=com.salvadorvertical.misepis"
        );
      }

      return;
    });
  },

  async changePassword({ commit }, data) {
    await axios.post(`${url}/auth/change-password`, data).then((response) => {
      // router.push({ name: "Login" });
    });
  },
};

const reset = {
  namespaced: true,
  actions,
};

export default reset;
